import { getDisplayString, MedplumClient } from "@medplum/core";
import { Condition } from "@medplum/fhirtypes";

import { ConditionClinicalStatus } from "@/fhir/enums/fhir-valuesets";
import {
  ProblemType,
  QuiltedHealthValueSets,
  ResourceClientVisibility,
} from "@/fhir/enums/quilted-health";
import { getCategory, joinReferenceString } from "@/utils/medplum";

export async function fetchProblemsBadges(medplum: MedplumClient, clientId: string) {
  const conditions = await medplum.searchResources("Condition", {
    subject: joinReferenceString("Patient", clientId),
    category: ConditionClinicalStatus.ProblemListItem,
  });

  return conditions;
}

export function filterProblemsByType(problems: Condition[], type: ProblemType) {
  const filterProblems = (problem: Condition): boolean => {
    const problemType = getCategory(problem.category, QuiltedHealthValueSets.ProblemType)?.code;
    return problemType === type;
  };

  return problems.filter(filterProblems);
}

export function filterProblemsBadgesByVisibility(problems: Condition[], type: ProblemType) {
  const filterProblems = (problem: Condition): boolean => {
    const isVisible =
      getCategory(problem.category, QuiltedHealthValueSets.ResourceClientVisibility)?.code ==
      ResourceClientVisibility.Visible;

    return isVisible;
  };

  const displayStrings = problems
    .filter(filterProblems)
    .map((problem) => getDisplayString(problem))
    .filter(Boolean) as string[];

  return [...new Set(displayStrings)];
}
